import handleUnsupportedBrowser from "./handle-unsupported-browser";

export default function verifySupportedBrowser() {
  if (!navigator.cookieEnabled) {
    handleUnsupportedBrowser();
  }
}
